import { ValueType } from 'react-select/src/types'

import { ReactSelectValue } from 'components/HostActions/Interfaces/HostActionProps'

export const isReactSelectFormat = (value: ValueType<ReactSelectValue>): value is ReactSelectValue =>
  !!value && 'label' in value && 'value' in value
